<template>
    <div class="md:w-3/5 bg-grey-lightest p-4">
        <h2 class="text-center text-black border-b my-2">Fotogalerij</h2>
        <div class="flex flex-wrap justify-center items-center">
            <div v-for="img in images">
                <img @click="modal(img)" alt="Ons werk" class="cursor-pointer w-24 md:w-64 m-2" :src="getImg(img)"/>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ImageGrid",
        props: ['images'],
        methods: {
            getImg(img) {
                if (process.env.NODE_ENV !== 'production') {
                    return 'http://127.0.0.1:8000' + img;
                }
                else {
                    return 'https://api.vloerverwarminginfrezen.info' + img;
                }
            },
            modal(img) {
                console.log(this.getImg(img));
            }
        }
    }
</script>

<style scoped>
    img {
        border-radius: 10px;
        transition: 400ms;
    }

    img:hover {
        filter: brightness(90%);
        border-radius: 0;
        transition: 200ms
    }
</style>
